<template>
    <div class="boxsliders">
        <h2>Valitse mitat</h2>
        <form v-on:submit.prevent>
            <FormSlider text="Leveys" text2="(mm)" v-model="w" :initialValue="w" :max="max" formName="w" id="w"></FormSlider>
            <FormSlider v-if="showDepth" text="Syvyys" text2="(mm)" v-model="d" :initialValue="d" :max="max" formName="d" id="d"></FormSlider>
            <FormSlider text="Korkeus" text2="(mm)" v-model="h" :initialValue="h" :max="max" formName="h" id="h"></FormSlider>
            <button class="btn btn-primary btn-submit btn-continue" @click="formSubmit">Jatka tarjouspyyntöön</button>

        </form>

    </div>
</template>

<script>

import FormSlider from "@/components/FormSlider.vue";
import axios from "axios"
import VueAxios from "vue-axios"

export default {
    name: "BoxSliders",
    components: {
        FormSlider,
        VueAxios,
        axios
    },
    props: {
        msg: {
            type: [String, null],
        },
        max: {
            defaul: 1000,
        }
    },
    computed: {
      showDepth: function () {
        let model = this.$parent.model;
        if(model == 6) { 
            return false;
        }
        else {
            return true;
        }
      }
    },
    methods: {
        formChanged() {
            console.log('formChanged');
            clearTimeout(this.formTimeout);
            var thisComponent = this;
            this.formTimeout = setTimeout(function() {
                thisComponent.formBoxPreviewSubmit();
            }, 100);
        },
        formSubmit() {
            this.submitBoxPreview();
            let formObject = {'w': this.w, 'd': this.d, 'h': this.h };
            console.log('formObject:', formObject);
            this.$emit('showForm', formObject);
        },
        formBoxPreviewSubmit() {
            console.log('Formsubit for box preview');
            console.log('w: ', this.w);
            console.log('d: ', this.d);
            console.log('h: ', this.h);
            this.submitBoxPreview();
        },
        getBoxSubmitData() {
            /*update this also if more box variables comes! called from form submit ! */
            let model = this.$parent.model; //box model number
            var mac = this.$route.params.mac;
            return '?mac='+mac+'&model='+model+'&w='+this.w+'&d='+this.d+'&h='+this.h;
        },
        submitBoxPreview() {
            console.log('Ajax starting...');
            let axiosEndpoint = process.env.VUE_APP_BOX_DRAW_ENDPOINT;
            let model = this.$parent.model; //box model number
            if(model == false) {
                console.log('Ajax cancelled');
                return false; /* need this to prevent double loading with false param on init with box model */
            }
            var mac = this.$route.params.mac;
            console.log('osoite: ' + axiosEndpoint);
            var config = {
                /*
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET",
                    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
                },
                */
                //responseType: 'json',
                responseType: 'arraybuffer',
                crossDomain: true,

            };
            axios
            .get(axiosEndpoint+'?mac='+mac+'&model='+model+'&w='+this.w+'&d='+this.d+'&h='+this.h, config)
            .then(response => {
                /*
                var kk = this;
                setTimeout(function() {
                    kk.loaded = true;
                }, 100);
                */
                console.log('data image data received');
                //this.$emit('image', response.data);

                let bytes = new Uint8Array(response.data);
                let binary = bytes.reduce((data, b) => data += String.fromCharCode(b), '');
                this.$parent.$emit('imageUpdate', "data:image/jpeg;base64," + btoa(binary));
                //TODO ERRORHANDLING
                //this.$parent.$emit('imageError');
                //console.log(response.data);
                //this.companySettings = response.data;
            });
            return;
        }
    },
    mounted() {
        /* eslint no-unused-vars:off */
        this.$watch(vm => [vm.$parent.model, vm.w, vm.h, vm.d], val => {
          //console.log(val);
          var vm = this;
          clearTimeout(this.timer);
          //timer for slowing down backend queries
          this.timer = setTimeout(function() {
            vm.formChanged();
          }, 250);

        }, {
          immediate: true, // run immediately
          deep: true // detects changes inside objects. not needed here, but maybe in other cases
        })
    },
    data() {
        return {
            w: 100,
            d: 100,
            h: 80,
            timer:0,
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 {
    font-size: 22px;
}
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
.btn-continue {
    margin-top: 30px;
    margin-bottom: 8px;
}
</style>
